import { render } from "./GroupAppItem.vue?vue&type=template&id=1a17bf31&scoped=true"
import script from "./GroupAppItem.vue?vue&type=script&lang=js"
export * from "./GroupAppItem.vue?vue&type=script&lang=js"

import "./GroupAppItem.vue?vue&type=style&index=0&id=1a17bf31&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a17bf31"]])

export default __exports__